import { Image, Text, View } from '@react-pdf/renderer';
import { IMAGE_PATHS } from 'constants/imagePaths';
import { checkObjHasValues } from 'utils';
import parse from 'html-react-parser';
import { sanitizeHtml } from 'components/sanitizeHtml';

const Projects = ({ styles, data, headerTitle }: any) => {
	return (
		<View style={styles.projectsField}>
			<Text style={styles.heading}>{headerTitle}</Text>

			<View style={styles.rightDetails}>
				{data?.map((res: any) => {
					if (checkObjHasValues(res)) {
						return (
							<View key={`proj-${res?.projectTitle}-${res?.projectLink}`}>
								<Text style={styles.title}>{res?.projectTitle}</Text>
								{res?.projectLink && (
									<View style={styles.urlBox}>
										<Image style={styles.urlIcon} src={IMAGE_PATHS.urlIcon} />
										<Text style={styles.urlData}>{res?.projectLink}</Text>
									</View>
								)}
								<Text style={styles.detailSubText}>
									{parse(sanitizeHtml(res?.projectDesc || ''))}
								</Text>
							</View>
						);
					}
				})}
			</View>
		</View>
	);
};

export default Projects;
